export default element => element.addEventListener(
  'webkitAnimationEnd',
  () => { element.style.display = 'none'; }, // eslint-disable-line
  false,
);
